export const BLACK_FRIDAY_START_DATE = new Date(2025, 10, 17)
export const BLACK_FRIDAY_END_DATE = new Date(2025, 11, 2)
